import styled from "styled-components";

export const StyledChatComponent = styled.div`
    display: flex;
    flex-direction: column;
    /* 
        height change:
        was previously height: (props) => (props.delinked ? "550px" : "450px");
        changed because we need more space for the modals.
    */
    height: 550px;
`;
